<div class="fs-2 success with-close" mat-dialog-title>
    Prolongation de votre essai offert !
    <i class="fa fa-close" (click)="onNoClick()" aria-hidden="true"></i>
</div>
<div mat-dialog-content>
    <b>Félicitations, votre essai offert à LyBox a bien été prolongé de 7 jours supplémentaires !</b>
    <p class="text-center mt-4 mb-4">
        <img src="assets/checked.png">
    </p>
    <p class="mb-0">
        La meilleure solution pour profiter au mieux de votre essai, est de suivre les instructions en bas à gauche de
        votre écran.<br/><br/>
        Voici les étapes essentielles pour bien utiliser LyBox :
    </p>
    <ol>
        <li>Lancer une recherche (Menu “Mes recherches” à gauche)</li>
        <li>Enregistrer votre recherche (Cliquez sur “Enregistrer la recherche” en haut à droite)</li>
        <li>Analyser une annonce (Cliquez sur “Ouvrir l’analyse” sur n’importe quelle annonce)</li>
        <li>Enregistrer une annonce en favori (Cliquez sur “Ajouter aux favoris” en haut à droite d’une annonce
            ouverte).
        </li>
    </ol>
    <p class="mb-0">
        Êtes-vous prêt à devenir un investisseur rentable ?
    </p>
</div>
<div mat-dialog-actions>
    <button type="button" (click)="onNoClick()" class="btn btn-outline w-100">
        C’est parti !
    </button>
</div>
